export default function getDashlaneUrl() {
  const isStaging = /staging|localhost/gi.test(window.location.href);

  return `https://${isStaging ? 'tests' : 'www'}.dashlane.com`;
}
